export const UI_SELECT: string = "ui_select";

export const UI_CLICK: string = "ui_click";
export const WETPAINT_A: string = "wetpaint-a";
export const WETPAINT_B: string = "wetpaint-b";
export const WETPAINT_C: string = "wetpaint-c";
export const WETPAINT_D: string = "wetpaint-d";
export const WETPAINT_E: string = "wetpaint-e";
export const SELECT_PATCH: string = "select-patch";
export const SHUFFLE: string = "shuffle";
export const STITCH_SOUND: string = "stitch-sound";
export const WIND_UP: string = "windup";
export const WIND_DOWN: string = "winddown";
export const WHISTLE_UP: string = "whistle-up";
export const WHISTLE_DOWN: string = "whistle-down";
export const WHOOSH1: string = "whoosh1";
export const WHOOSH2: string = "whoosh1";
export const WHOOSH3: string = "whoosh3";
export const WHOOSH4: string = "whoosh4";
export const ONBOARDING_SHOW: string = "onboarding-show";
export const LIFT_ART: string = "liftart";
export const WALL1_IMPACT: string = "wall1-impact";
export const WALL2_IMPACT: string = "wall2-impact";
export const WALL3_IMPACT: string = "wall3-impact";
export const SUCCESS: string = "Success";
export const DOOR_OPEN: string = "dooropen";
export const HANG_ART: string = "hangart";
export const BOTTLE_OPENING1: string = "BottleOpening1";
export const BOTTLE_OPENING2: string = "BottleOpening2";
export const BOTTLE_OPENING3: string = "BottleOpening3";
export const HEAVY_FABRIC: string = "heavyfabric";
export const FINAL_ART_APPEARS: string = "finalartappears";

export const WETPAINT: string[] = [
    WETPAINT_A,
    WETPAINT_B,
    WETPAINT_C,
    WETPAINT_D,
    WETPAINT_E,
];
export const WHOOSH: string[] = [
    WHOOSH1,
    WHOOSH2,
    WHOOSH3,
    WHOOSH4,
];
export const BOTTLE_OPENING: string[] = [
    BOTTLE_OPENING1,
    BOTTLE_OPENING2,
    BOTTLE_OPENING3,
];
